import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { IllustrativeView } from '@component/illustrative_view.component';
import { TopBar } from '@component/top_bar.component';
import { RouterService } from '@cortex-shim/router.service';
import { useResolve } from '@visiba/instantiation';
import { useEffect } from 'react';
import { useParams } from 'react-router';

export function ScreenDone() {
	const { conversationId } = useParams();
	const routerService = useResolve(RouterService);
	const analyticCtx = useAnalyticContext();

	useEffect(
		function whenMount() {
			analyticCtx.service.trackPageView({
				customTitle: 'Create new message: Done',
			});
		},
		[analyticCtx],
	);

	function handleNextClick() {
		analyticCtx.trackEvent('Clicked', 'Go to case button');

		if (conversationId) {
			routerService.navigateByUrl(`/visits/message/${conversationId}`);
		} else {
			routerService.navigateByUrl('/visits');
		}

		// TODO: Remove when angular is gone!
		if (
			(window as typeof window & { __TEMP__overrideNavigation: Record<string, unknown> | undefined })['__TEMP__overrideNavigation'] !=
			null
		) {
			window.location.reload();
		}
	}

	return (
		<>
			<TopBar.Content onAbort={null} />
			<IllustrativeView
				title={withTranslation('View.CreateNewMessage.ScreenDone.Title')}
				description={withTranslation('View.CreateNewMessage.ScreenDone.Description')}
				illustration='messageSent'
				callToAction={withTranslation('View.CreateNewMessage.ScreenDone.Button')}
				callToActionCallback={handleNextClick}
			/>
		</>
	);
}
